import React from 'react';
import { ArrowRightIcon, CheckCircleIcon } from 'lucide-react';
export function About() {
  return <section id="about" className="py-20 lg:py-28 bg-tlfc-stone" data-id="element-16">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10" data-id="element-17">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center" data-id="element-18">
          {/* Text Column */}
          <div className="reveal" data-id="element-19">
            <span className="text-xs uppercase tracking-wider text-tlfc-gold font-medium" data-id="element-20">
              About TLFC
            </span>
            <h2 className="mt-4 font-serif text-3xl md:text-4xl text-tlfc-text leading-tight" data-id="element-21">
              Over 50 years of getting it right.
            </h2>
            <div className="mt-6 space-y-4 text-tlfc-text-secondary leading-relaxed" data-id="element-22">
              <p data-id="element-23">
                Founded on the principle that every client deserves strategic
                thinking and personal attention, TLFC has grown into one of
                Melbourne's most respected mid-tier firms.
              </p>
              <p data-id="element-24">
                We combine the depth of a large practice with the responsiveness
                and care of a boutique — from conveyancing to complex commercial
                disputes.
              </p>
            </div>

            {/* Proof Points */}
            <div className="mt-8 space-y-3" data-id="element-25">
              <div className="flex items-start gap-3" data-id="element-26">
                <CheckCircleIcon className="w-5 h-5 text-tlfc-green flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-27" />
                <span className="text-sm text-tlfc-text-secondary" data-id="element-28">
                  Accredited specialists across multiple practice areas
                </span>
              </div>
              <div className="flex items-start gap-3" data-id="element-29">
                <CheckCircleIcon className="w-5 h-5 text-tlfc-green flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-30" />
                <span className="text-sm text-tlfc-text-secondary" data-id="element-31">
                  Recognised in Doyle's Guide and Best Law Firms – Australia
                </span>
              </div>
              <div className="flex items-start gap-3" data-id="element-32">
                <CheckCircleIcon className="w-5 h-5 text-tlfc-green flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-33" />
                <span className="text-sm text-tlfc-text-secondary" data-id="element-34">
                  Full-service firm: from conveyancing to complex commercial
                  disputes
                </span>
              </div>
            </div>

            {/* CTA */}
            <a href="#people" className="inline-flex items-center gap-2 mt-8 text-tlfc-gold font-medium hover:text-tlfc-gold-light transition-colors group" data-id="element-35">
              Meet the team
              <ArrowRightIcon className="w-4 h-4 transition-transform group-hover:translate-x-1" aria-hidden="true" data-id="element-36" />
            </a>
          </div>

          {/* Visual Column — Real Office Image */}
          <div className="reveal reveal-delay-2 relative" data-id="element-37">
            <div className="relative aspect-[4/3] rounded-2xl overflow-hidden shadow-card" data-id="element-38">
              <img src="https://images.unsplash.com/photo-1497366216548-37526070297c?w=800&q=80" alt="Modern law office interior with city views" className="absolute inset-0 w-full h-full object-cover" data-id="element-39" />
              {/* Subtle warm overlay */}
              <div className="absolute inset-0 bg-gradient-to-tr from-tlfc-dark/20 to-transparent" data-id="element-40" />

              {/* 50+ Years Badge */}
              <div className="absolute bottom-6 left-6 bg-white/95 backdrop-blur-sm rounded-xl px-5 py-4 shadow-lg" data-id="element-41">
                <div className="text-3xl font-serif text-tlfc-gold font-medium" data-id="element-42">
                  50+
                </div>
                <div className="text-xs text-tlfc-text-secondary mt-1" data-id="element-43">
                  Years of Excellence
                </div>
              </div>
            </div>

            {/* Decorative corner accent */}
            <div className="absolute -top-3 -right-3 w-24 h-24 border-t-2 border-r-2 border-tlfc-gold/30 rounded-tr-2xl" data-id="element-44" />
          </div>
        </div>
      </div>
    </section>;
}